// extracted by mini-css-extract-plugin
export default {"hideHistoryIcon":"MainDashboard_hideHistoryIcon__bJ1W9"};